import { useTranslation } from 'react-i18next';
import { Content } from '../../../models/content/types';
import {
  FeedCardWithData,
  FeedCardProps,
} from '../../content/solar-feed-card/solar-feed-card';
import './content-layouts.scss';

type HorizontalScrollRowProps = {
  children: React.ReactNode;
  title?: string;
};

const HorizontalScrollRow = ({ children, title }: HorizontalScrollRowProps) => {
  const { t } = useTranslation();
  return (
    <div
      className="content-layout__horizontal-scroll"
      role="region"
      aria-label={t('landing.scrollable_section', {
        title,
        defaultValue: `${title} — scrollable`,
      })}
    >
      {children}
    </div>
  );
};

type MobileHorizontalFeedCardsProps = {
  contents: Content[];
  analyticsData: FeedCardProps['analyticsData'];
  title?: string;
};

export const MobileHorizontalFeedCards = ({
  contents,
  analyticsData,
  title,
}: MobileHorizontalFeedCardsProps) => (
  <HorizontalScrollRow title={title}>
    {contents.map((content) => (
      <div className="content-layout__horizontal-scroll-card" key={content.id}>
        <FeedCardWithData
          content={content}
          analyticsData={analyticsData}
          compact
          fullHeight
          layout="vertical"
        />
      </div>
    ))}
  </HorizontalScrollRow>
);
